/**
 * Stupid hack to make React Query respect changing search params
 * 
 * @param searchParams
 * @param keys
 * @returns {*}
 */
const useSearchParamsEx = (searchParams, keys) => keys.reduce((acc, it) => ({
    ...acc,
    [it]: searchParams.get(it),
}), {})

export default useSearchParamsEx
